import { useSelector } from 'react-redux';
import cc from 'classcat';

import { getEnvironment } from '#src/store/environment/selectors';

import { WeightLossChart } from './WeightLossChart.js';
import styles from './styles.module.scss';
import { CloudinaryChart } from './CloudinaryChart';

const useBooleanEnvironmentVar = (name) => {
  const { [name]: envVar } = useSelector(getEnvironment);
  return envVar === 'true';
};

export const QuizWeightLossChart = ({
  startWeight,
  goalWeight,
  planHighlights,
}) => {
  // feature-flagging the dynamic chart as a safeguard;
  // allows us to switch it off without a code deployment
  const useStaticChart = useBooleanEnvironmentVar('USE_STATIC_CHECKOUT_CHART');
  const highlightsTitle =
    startWeight && goalWeight
      ? 'Highlights of your customized plan'
      : 'What you’ll get';

  return (
    <div className={styles.weightLossChartWrapper}>
      <div className={styles.imageWrapper}>
        {useStaticChart ? (
          <CloudinaryChart />
        ) : (
          <WeightLossChart startWeight={startWeight} goalWeight={goalWeight} />
        )}
      </div>
      <div className={styles.planHighlights}>
        <p className={styles.planTitle}>{highlightsTitle}</p>
        <ul className={styles.planList}>
          {planHighlights.map(({ id, text, featured = false }) => {
            return (
              <li
                key={'highlight' + id}
                className={cc([
                  { [styles.featured]: featured },
                  styles.highlight,
                ])}
              >
                {text}
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};
